require('../bootstrap');
require('../plugins');
require('../vendor/hover-copy');
require('../vendor/loader-submit');
